// extracted by mini-css-extract-plugin
export default {"infoNumberIcon":"InfoNumberIcon_infoNumberIcon__oI7O1","infoNumberCircle":"InfoNumberIcon_infoNumberCircle__t+CC7","correction":"InfoNumberIcon_correction__G35ru"};